import React, { useCallback } from 'react';
import { Formik } from 'formik';
import { useDispatch } from "react-redux";
import { FormError } from "./fields/FormError";
import classNames from 'classnames';
import {
  Form,
  InputGroup,
} from 'react-bootstrap';
import {
  throttle
} from 'lodash';
import {
  isEnterKey,
} from '@utils';

import {
  setInfluencerApplicationCache
} from '@actions';
import step1Validations from './step1Validations';

const yup = require("yup");

const validationSchema = yup.object(step1Validations);

const Step1 = ({ goToNextStep }) => {
  const dispatch = useDispatch();
  const handleNextStepOnClick = () => {
    goToNextStep();
	};

   const preventSubmitOnEnterKeydown = useCallback(
    throttle(keyEvent => {
      if (isEnterKey(keyEvent)) {
        keyEvent.persist()
        keyEvent.preventDefault();
      }
    }, 1),
    []
  );

  return (
     <Formik
      validateOnChange={false}
      validateOnBlur
      validationSchema={validationSchema}
      onSubmit={(
        data,
        { setFieldValue, setErrors, setSubmitting }
      ) => {
        dispatch(setInfluencerApplicationCache(data));
        handleNextStepOnClick();
      }}
      initialValues={{
        email: "",
        phoneNumber: "",
        firstName: "",
        lastName: "",
        location: "",
        username: "",
        instagramUsername: "",
        twitterUsername: "",
        goodFitInfo: ""
      }}
      >
      {({
        handleSubmit,
        handleChange,
        values,
        errors,
        setFieldValue,
        isSubmitting,
        setErrors
      }) => (
           <Form
              noValidate
              onSubmit={data => {
                data.preventDefault();
                handleSubmit();
              }}
              onKeyDown={preventSubmitOnEnterKeydown}
            >
              <Form.Group>
                <Form.Label className="form-control-label">
                  Email
                </Form.Label>

                <Form.Control
                  name="email"
                  placeholder="Email Address"
                  type="email"
                  className={classNames("form-control", {"error": errors.email && errors.email.length > 0})}
                  value={values.email}
                  onChange={handleChange}
                  required
                />
                { errors.email ? <FormError error={errors.email} /> : null }
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-control-label">
                  Phone Number
                </Form.Label>

                <Form.Control
                  name="phoneNumber"
                  placeholder="Phone Number"
                  type="text"
                  className={classNames("form-control", {"error": errors.phoneNumber && errors.phoneNumber.length > 0})}
                  value={values.phoneNumber}
                  onChange={handleChange}
                  required
                />
                { errors.phoneNumber ? <FormError error={errors.phoneNumber} /> : null }
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-control-label">
                  First Name
                </Form.Label>

                <Form.Control
                  name="firstName"
                  placeholder="First Name"
                  type="text"
                  className={classNames("form-control", {"error": errors.firstName && errors.firstName.length > 0})}
                  value={values.firstName}
                  onChange={handleChange}
                  required
                />
                { errors.firstName ? <FormError error={errors.firstName} /> : null }
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-control-label">
                  Last Name
                </Form.Label>

                <Form.Control
                  name="lastName"
                  placeholder="Last Name"
                  type="text"
                  className={classNames("form-control", {"error": errors.lastName && errors.lastName.length > 0})}
                  value={values.lastName}
                  onChange={handleChange}
                  required
                />
                { errors.lastName ? <FormError error={errors.lastName} /> : null }
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-control-label">
                  Location
                </Form.Label>

                <Form.Control
                  name="location"
                  placeholder="Where do you live?"
                  type="text"
                  className={classNames("form-control", {"error": errors.location && errors.location.length > 0})}
                  value={values.location}
                  onChange={handleChange}
                  required
                />
                { errors.location ? <FormError error={errors.location} /> : null }
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-control-label">
                  Username
                </Form.Label>
                <InputGroup className="mb-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>nudiez.tv/</InputGroup.Text>
                  </InputGroup.Prepend>

                  <Form.Control
                    name="username"
                    placeholder="Enter your desired username"
                    type="text"
                    className={classNames("form-control", {"error": errors.username && errors.username.length > 0})}
                    value={values.username}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
                { errors.username ? <FormError error={errors.username} /> : null }
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-control-label">
                  Public Instagram Username
                </Form.Label>
                <InputGroup className="mb-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text><i className="fab fa-instagram"></i>instagram.com/</InputGroup.Text>
                  </InputGroup.Prepend>

                  <Form.Control
                    name="instagramUsername"
                    placeholder="Enter your public Instagram name"
                    type="text"
                    className={classNames("form-control", {"error": errors.instagramUsername && errors.instagramUsername.length > 0})}
                    value={values.instagramUsername}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
                { errors.instagramUsername ? <FormError error={errors.instagramUsername} /> : null }
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-control-label">
                  Twitter Username
                </Form.Label>
                <InputGroup className="mb-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text><i className="fab fa-twitter"></i>twitter.com/</InputGroup.Text>
                  </InputGroup.Prepend>

                  <Form.Control
                    name="twitterUsername"
                    placeholder="Enter your twitter username"
                    type="text"
                    className={classNames("form-control", {"error": errors.twitterUsername && errors.twitterUsername.length > 0})}
                    value={values.twitterUsername}
                    onChange={handleChange}
                    required
                  />
                </InputGroup>
                { errors.twitterUsername ? <FormError error={errors.twitterUsername} /> : null }
              </Form.Group>
              <Form.Group>
                <Form.Label className="form-control-label">
                  Good Fit Info
                </Form.Label>

                <textarea
                  name="goodFitInfo"
                  placeholder="Why do you think you'd be a good addition to Nudiez?"
                  type="text"
                  className={classNames("form-control", {"error": errors.goodFitInfo && errors.goodFitInfo.length > 0})}
                  value={values.goodFitInfo}
                  onChange={handleChange}
                  required
                />
                { errors.goodFitInfo ? <FormError error={errors.goodFitInfo} /> : null }
              </Form.Group>
              <button type="submit" className="btn pink-button">Continue</button>
            </Form>
      )}
    </Formik>
  )
}

export default Step1;